var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.dataDetail != null)?_c('div',[_c('customer',{attrs:{"data":_vm.dataDetail}}),_c('pesanan',{attrs:{"data":_vm.dataDetail}}),_c('detail-rinci',{attrs:{"data":_vm.dataDetail}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }